import { assistantAdapter } from "./adapters/assistant";
import { calendarAdapter } from "./adapters/calendar";
import { chatAdapter } from "./adapters/chat";
import { docsAdapter } from "./adapters/docs";
import { driveAdapter } from "./adapters/drive";
import { emailAdapter } from "./adapters/email";
import { peopleAdapter } from "./adapters/people";
import type { ModuleSearchAdapter } from "./types";

// Order at launch per
// docs/superpowers/specs/2026-05-19-global-search-redesign-design.md §2:
// Email, Chat, Planner, Vault, Write, People, Assistant.
export const adapters: ModuleSearchAdapter[] = [
  emailAdapter,
  chatAdapter,
  calendarAdapter,
  driveAdapter,
  docsAdapter,
  peopleAdapter,
  assistantAdapter,
];
